export const signupRules = {
  email: 'required|email',
  password: ['required', 'min:10', 'regex:/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])/'],
  password_repeat: 'required|same:password',
  first_name: 'required|string',
  last_name: 'required|string',
  instruments2: 'array'
}

export const freeTrialRules = {
  business_email: 'required|email',
  first_name: 'required|string',
  last_name: 'required|string',
  company: 'required',
  number_of_traders: 'required|numeric',
  phone: 'required|numeric',
  country: 'required',
  state: 'required'
}

export const passResetRules = {
  email: 'required|email',
  password: ['required', 'min:10', 'regex:/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])/'],
  password_repeat: 'required|same:password',
}

export const errorMessages = {
  'regex': 'The :attribute must contain at least 1 digit, 1 letter and 1 special character'
}

export const customNames = {
  password_repeat: 'confirm password',
  instruments2: 'instruments'
}
